import { forwardRef } from "react";
import {
  Textarea,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from "@chakra-ui/react";

const InputBase = (
  { name, label, error = null, labelSize = "sm", ...rest },
  ref
) => {
  return (
    <FormControl isInvalid={!!error}>
      {label && (
        <FormLabel
          htmlFor={name}
          fontSize={labelSize}
          color="#818A8F"
          lineHeight="17.36px"
        >
          {label}
        </FormLabel>
      )}

      <Textarea
        name={name}
        id={name}
        ref={ref}
        color="black.100"
        bg="#F5F5FB"  
        fontSize="sm"
        fontWeight={600}
        lineHeight="17.36px"
        border="1px solid #F5F5FB"
        borderRadius="8px"
        p="12px 16px"
        resize='none'
        _disabled={{
          color: "#515D63",
          bg: "#CCCFD1",
          cursor: "not-allowed",
        }}
        _hover={{
          borderColor: "none",
          boxShadow: "md",
        }}
        _placeholderShown={{
          bg: "white",
          borderColor: "#CCCFD1",
          _disabled: {
            bg: "#CCCFD1",
          },
        }}
        {...rest}
      />

      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};

export const CustomTextarea = forwardRef(InputBase);
